import { render, staticRenderFns } from "./External.vue?vue&type=template&id=823ab73c&scoped=true&"
import script from "./External.vue?vue&type=script&lang=ts&"
export * from "./External.vue?vue&type=script&lang=ts&"
import style0 from "./External.vue?vue&type=style&index=0&id=823ab73c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823ab73c",
  null
  
)

export default component.exports